<style lang="sass" scoped>
.ctn
  border: 1px solid #D4D4D4
  border-radius: 4px
  line-height: 1
  height: 42px
  background: #fff
  border-bottom: 1px solid #D4D4D4
  border-left: none
  > .fr
    margin-top: 15px
    .el-icon-caret-bottom
      &.open
        transform: rotate(180deg)
    .more
      display: inline-block
      padding-right: 20px
      border-right: 1px solid #D4D4D4
      color: #999
      cursor: pointer
    .btns
      padding: 0 10px
      // border-left: 1px solid #D4D4D4
      span
        cursor: pointer
        margin: 0 10px
  .left_fl
    float: left
    width: calc(100% - 190px)
    overflow: hidden
    height: 100%
    &.open
      overflow: visible
    .items-ctn
      // height: 100%
      overflow: hidden
      position: relative
      z-index: 1
      border-left: 1px solid #D4D4D4
      .item
        height: 41px
        padding: 10px
        border-right: 1px solid #D4D4D4
        background: #fff
        border-bottom: 1px solid #D4D4D4
        float: left
        span
          display: inline-block
          border-right: 1px solid #D4D4D4
          padding-right: 10px
        ::v-deep .el-input, ::v-deep .el-select
          width: 120px
          input
            height: 20px
            border: none
            padding-right: 0
          .el-select__caret
            height: auto
            position: relative
            top: -3px
        // height: 12px
        ::v-deep .el-date-editor
          width: 200px
          padding: 0 10px
          border: none
          height: 20px
          input
            width: 80px
            height: 20px
            border: none
            padding-right: 0
          .el-input__icon
            display: none
          .el-range-separator
            width: 20px
</style>

<template lang="pug">
.ctn
  .left_fl(:class="{'open': isOpen}")
    .items-ctn(ref="itemCtn" width="100%")
      .item
        span 广告名称
        el-input(v-model="searchOpt.materialName" size="mini" placeholder="请输入")
      .item
        span 单次曝光
        el-select(v-model="searchOpt.contentTime" size="mini" placeholder="请输入")
          el-option(v-for="(item, i) in contentTimeList" :key="i" :label="item.dictItemName+'秒'" :value="item.dictItemName")
  .fr
    span.more(v-if="showMore" @click="isOpen = !isOpen")
      i.el-icon-caret-bottom(:class="{'open': isOpen}")
      span 更多
    .fr.btns
      span(style="color: #FF3973;" @click="change(1)") 搜索
      span(@click="change('')") 重置
</template>

<script>
export default {
  name: 'ListSearchCp',
  data () {
    return {
      isOpen: false,
      orderSnTypes: [],
      contentTimeList: [],
      searchOpt: {},
      playTime: [],
      createTime: [],
      showMore: true
    }
  },
  watch: {
    playTime (v) {
      this.searchOpt.playStartDate = v && v[0] || ''
      this.searchOpt.playEndDate = v && v[1] || ''
    },
    createTime (v) {
      this.searchOpt.createStartDate = v && v[0] || ''
      this.searchOpt.createEndDate = v && v[1] || ''
    }
  },
  async created () {
    this.contentTimeList = await this.getContentTimes()
  },
  mounted () {
    this.$nextTick(() => {
      this.handleMoreShow()
      window.addEventListener('resize', this.handleMoreShow)
      this.$root.$on('rootEmitCloseLeft', () => {
        setTimeout(() => {
          this.handleMoreShow()
        }, 200)
      })
    })
  },
  methods: {
    handleMoreShow () {
      if (this.$refs.itemCtn && this.$refs.itemCtn.clientHeight > 50) this.showMore = true
      else this.showMore = false
    },
    change (type) {
      if (!type) {
        this.searchOpt = {}
        this.playTime = []
        this.createTime = []
      }
      this.$emit('change', this.searchOpt)
    },
    async getContentTimes () { // 获取购买时长列表
      if (!this.$store.state.bmap.labelTimeSlotList.length) await this.$store.dispatch('getTimeSlotList')
      return this.$store.state.bmap.labelTimeSlotList || []
    }
  }
}
</script>
